export const supportTicketUrl = 'client/support_ticket/';
